import { ZERO } from "app/pages/activation/components/HomeWithData/ShareData/constants";
import type { IRankTrackerWidgetData } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/types";

import * as SC from "../BodyByState/styles";
import { KEYWORDS_DECLINING, KEYWORDS_MOVED_UP } from "../BodyByState/texts";
import { MetricCardVariant } from "../BodyByState/types";

import { MetricCard } from "./MetricCard";

type RightAsideDefaultProps = {
    data: IRankTrackerWidgetData;
};

export const RightAsideDefault = ({ data }: RightAsideDefaultProps) => {
    const movedUpVariant = data.keywordsMovedUp > ZERO ? MetricCardVariant.Up : MetricCardVariant.Neutral;
    const decliningVariant = data.keywordsDeclining > ZERO ? MetricCardVariant.Declining : MetricCardVariant.Neutral;

    return (
        <SC.RightAsideCardsWrapper>
            <MetricCard
                value={data.keywordsMovedUp}
                labelKey={KEYWORDS_MOVED_UP}
                variant={movedUpVariant}
                dataAutomation="share-data-rank-tracker-card-moved-up"
            />
            <MetricCard
                value={data.keywordsDeclining}
                labelKey={KEYWORDS_DECLINING}
                variant={decliningVariant}
                dataAutomation="share-data-rank-tracker-card-declining"
            />
        </SC.RightAsideCardsWrapper>
    );
};
